var firebase = require('../firebase');
var toastr = require('toastr');
var Messages = require('../helpers/Messages');
var userActions = require('./userActions');

var { fbAuth, fbDb, fbStorage } = firebase;

module.exports = {
	fetching: function() {
		return {
			type: "DATA_FETCHING"
		};
	},

	fetched: function() {
		return {
			type: "DATA_FETCHED"
		};
	},

	fetch: function(timeout) {
		var me = this;

		return function(dispatch) {

			setTimeout(function(){
				dispatch(me.fetched());
			}, timeout || 1000);
			
			dispatch(me.fetching());
		}
	},

	initAuth: function(user) {
		return {
			type: "INIT_AUTH",
			payload: user
		};
	},

	signInSuccess: function(user) {
		return {
			type: "SIGNIN_SUCCESS",
			payload: user
		};
	},

	signInAdminSuccess: function(user) {
		return {
			type: "SIGNIN_ADMIN_SUCCESS",
			payload: user
		};
	},

	signInError: function(error) {
		return {
			type: "SIGNIN_ERROR",
			payload: error
		};
	},

	signOutSuccess: function() {
		return {
			type: "SIGNOUT_SUCCESS"
		};
	},

	signOutError: function(error) {
		return {
			type: "SIGNOUT_ERROR",
			payload: error
		};
	},

	signUpSuccess: function(result) {
		return {
			type: "SIGNUP_SUCCESS",
			payload: result
		};
	},

	signUpError: function(error) {
		return {
			type: "SIGNUP_ERROR",
			payload: error
		};
	},

	onAuthChange: function(user) {
		var me = this;

		return function(dispatch) {
			if (user) {
				fbDb.ref(`users/${user.uid}`)
				.once('value', (user) => {
					var { isAdmin, status, userType } = user.val();
					
					if (isAdmin) {
						dispatch(me.signInAdminSuccess({
							auth: true,
							isAdmin: isAdmin,
							key: user.key,
							status: status,
							userType: userType
						}))
					} else {
						dispatch(me.signInSuccess({
							auth: true,
							isAdmin: false,
							uid: user.key,
							status: status,
							userType: userType
						}))
					}
				})
			}
		};
	},

	forgot: function(data) {
		var me = this;

		return function(dispatch) {
			fbAuth.sendPasswordResetEmail(data.email).then(function() {
				toastr.success('Foi enviado uma requisição de mudança de senha ao seu e-mail!');
			}, function(error) {
				toastr.error('E-mail não encontrado!');
			});
		};
	},

	signIn: function(data) {
		var me = this;

		return function(dispatch) {
			fbAuth.signInWithEmailAndPassword(data.email, data.pass)
			.then(result => {
				fbDb.ref(`users/${result.uid}`)
				.once('value', (user) => {
					dispatch(me.signInSuccess(
						Object.assign(
							{}, result, user.val()
						)
					));
				})
			}).catch(error => {
				toastr.error(Messages[error.code]);
				dispatch(me.signInError(error))
			});

			dispatch(me.fetching());
		};
	},

	signInAdmin: function(data) {
		var me = this;

		return function(dispatch) {
			fbAuth.signInWithEmailAndPassword(data.email, data.pass)
			.then(result => {
				fbDb.ref(`users/${result.uid}`)
				.once('value', (user) => {
					var { isAdmin } = user.val();

					if (isAdmin) {
						dispatch(me.signInAdminSuccess({
							auth: true,
							isAdmin: isAdmin,
							key: user.key
						}));
					} else {
						toastr.error('Você não possui os privilégios necessários para executar esta ação.');
						dispatch(me.signInError('error'))
					}
				})
			}).catch(error => {
				toastr.error(Messages[error.code]);
				dispatch(me.signInError(error))
			});

			dispatch(me.fetching());
		};
	},

	signUp: function(data) {
		var me = this;
		var created = false;
		return function(dispatch) {
			fbAuth.createUserWithEmailAndPassword(data.email, data.pass)
			.then(result => {
				dispatch(userActions.createUser({
					name: data.name,
					email: result.email,
					phone: data.phone,
					fgtype: data.fgtype,
					uid: result.uid,
					cpf: data.cpf,
					cnpj: data.cnpj,
					address: data.address,
					city: data.city,
					state: data.state,
					nickname: data.nickname,
					paymentDay: data.paymentDay,
					documentFile: data.documentFile
				}));

				created = true;

				if(data.fgtype === 1) {
					me.uploadImage(dispatch, {
						result: result,
						documentFile: data.documentFile
					});
				} else {
					toastr.success('Usuário criado com sucesso!');

					dispatch(me.signUpSuccess(Object.assign({}, 
						result, {status: 1}
					)));
				}
			}).catch(error => {
				if(data.fgtype === 0 || !created) {
					toastr.error('Ocorreu um erro ao processar a solicitação')
					dispatch(me.signUpError(error))
				}
			});

			dispatch(me.fetching());
		};
	},

	uploadImage: function(dispatch, data) {
		var me = this;
		var xhr = new XMLHttpRequest();
		xhr.open('GET', data.documentFile, true);
		xhr.responseType = 'blob';
		xhr.onload = function(e) {
		  if (this.status == 200) {
		    var blobFile = this.response;
		    var documentRef = fbStorage.ref().child('images/clients/'+data.result.uid+'/document.jpg');
		    documentRef.put(blobFile).then(result => {
		    	toastr.success('Usuário criado com sucesso!');
				dispatch(me.signUpSuccess(Object.assign({}, 
					data.result, {status: 0}
				)));
			}).catch(error => {
				toastr.error('Ocorreu um erro ao processar a solicitação')
				dispatch(me.signUpError(error))
			});
		  }
		};
		xhr.send();
	},

	signOut: function() {
		var me = this;

		return function(dispatch) {
			fbAuth.signOut()
			.then(() => {
				dispatch(me.signOutSuccess());
				window.location.reload('/');
			});
				
			dispatch(me.fetching());
		};
	}
};


// WEBPACK FOOTER //
// ./src/actions/authActions.js